// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o5-1";
export var messageSideRight = "_o5-2";
export var subscribeToBackInStockBubbleContainer = "_o5-0";